import { IOption } from "@digital-services/ui";

export enum ResourceType {
  Charger = "Charger",
  Gateway = "Gateway"
}

export const resourceTypeOptions: IOption[] = Object.values(ResourceType).map(
  element => {
    return {
      value: element,
      label: element
    };
  }
);

export enum EntityType {
  User = "User",
  Organization = "Organization"
}

// Despite the fact actual values for Relationship filter is taken from backend
// this enum is needed for Frontend/TypeScript code
export enum RelationshipType {
  Owner = "Owner",
  Reseller = "Reseller",
  ServiceProvider = "ServiceProvider"
}

// data is expected from backend, and `value` will be used for further filtering flow
export const relationshipOptions = (data: RelationshipType[]): IOption[] =>
  data.map(element => {
    return {
      value: element,
      label: element
    };
  });

export interface ResourceMetadata {
  key: string;
  value: string;
}

export enum ResourceMetadataKeys {
  EVECommunicationId = "EVECommunicationId", // aka "GUID" from EVE
  ProductFamilyName = "ProductFamilyName", // aka Device Type
  ProductName = "ProductName",
  ProductVariantName = "ProductVariantName",
  ProductID = "ProductID" // aka "6AGC Code from EVE
}

export interface Relationship {
  createdOn: string;
  entityId: string; // GUID
  entityName: null | string;
  entityType: EntityType;
  relationshipType: RelationshipType;
}

export interface SingleResourceBasicModel {
  id: string;
  name: string;
  createdOn: string;
  serialNumber: string;
  resourceType: ResourceType;
  metadata: ResourceMetadata[];
}

export interface ResourceSummaryModel {
  id: string;
  name: string;
  createdOn: string;
  serialNumber: string;
  resourceType: ResourceType;
  productFamilyName: string; // aka deviceType
  relationships: Relationship[];
  metadata: ResourceMetadata[];
}

export interface PagedResourcesResponse {
  resources: ResourceSummaryModel[];
  total: number;
}

export interface DistinctResourcesMetadataValuesResponse {
  key: string;
  values: string[];
}
